export default __webpack_public_path__ + "static/media/lg_sie1.3aeb2e62.svg";